function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { CSSProperties, Ref, FC } from 'react';
import cn from 'classnames';
import { SkeletonVerticalCard as VerticalCard } from './VerticalCard/Skeleton-VerticalCard';
import { SkeletonHorizontalCard as HorizontalCard } from './HorizontalCard/Skeleton-HorizontalCard';
require("./Skeleton.css");
var styles = {
  "Root": "Skeleton-module-Root__LY",
  "skeleton": "Skeleton-module-skeleton_muH",
  "animated": "Skeleton-module-animated_321"
};
const SkeletonTypes = {
  horizontalCard: 'horizontalCard',
  verticalCard: 'verticalCard'
};
export const Skeleton = ({
  width,
  height,
  borderRadius,
  className,
  type,
  style = {},
  animated = true,
  controlRef,
  innerRef,
  ...props
}) => {
  switch (type) {
    case SkeletonTypes.verticalCard:
      return /*#__PURE__*/React.createElement(VerticalCard, null);
    case SkeletonTypes.horizontalCard:
      return /*#__PURE__*/React.createElement(HorizontalCard, null);
    default:
      return /*#__PURE__*/React.createElement("div", _extends({
        className: cn(styles.Root, {
          [styles.animated]: animated
        }, className),
        style: {
          width,
          height,
          borderRadius,
          ...style
        },
        ref: controlRef
      }, props));
  }
};
if (process.env.NODE_ENV !== 'production') {
  Skeleton.displayName = 'Skeleton';
}